import {
  Component, DoCheck,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {ModbusSignal} from '@models/adminstration/gateway/gateway-configuration/modbus-signal';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {DATA_TYPE} from '@constants/data-type.constant';

@Component({
    selector: 'scitis-admin-gateway-modbus-register-signals',
    templateUrl: './gateway-modbus-register-signals.component.html',
    styleUrls: ['./gateway-modbus-register-signals.component.scss'],
    standalone: false
})
export class GatewayModbusRegisterSignalsComponent implements OnInit, DoCheck {

  @Input()
  signal: ModbusSignal = new ModbusSignal();

  @Input()
  byteOrder: string[] = [];

  @Output()
  removeSignalChangeEvent = new EventEmitter<ModbusSignal>();

  @Output()
  formIsValid = new EventEmitter<boolean>();

  ALLOWED_DATA_TYPES: DATA_TYPE[] = [DATA_TYPE.INT16, DATA_TYPE.UINT16, DATA_TYPE.INT32, DATA_TYPE.UINT32, DATA_TYPE.FLOAT];
  shortData: string[] = [DATA_TYPE.INT16, DATA_TYPE.UINT16];
  modbusRegisterSignalForm: UntypedFormGroup = new UntypedFormGroup({});
  BITMASK_MIN: number = 0;
  private maxUInt16: number = 65535;
  private maxUInt32: number = 4294967295;

  ngOnInit(): void {
    this.generateModbusRegisterForm(this.signal);
  }

  ngDoCheck() {
    if(this.signal.hasChanged) {
      this.updateSignalForm();
      this.signal.hasChanged = false;
    }
  }

  get formControls() {
    return this.modbusRegisterSignalForm.controls;
  }

  removeSignal() {
    this.removeSignalChangeEvent.emit(this.signal);
  }

  onChangeDataType(event: any) {
    this.signal.type = event;
    this.formControls.bitmask.setValue(this.getMax(this.signal.type));
    this.onUpdateSignalProperties();
  }

  onChangeByteOrder(event: any){
    this.signal.order = this.byteOrder.indexOf(event);
  }

  onUpdateSignalProperties() {
    this.signal.name = this.formControls.name.value;
    this.signal.bitmask = this.formControls.bitmask.value;
    this.formIsValid.emit(!this.modbusRegisterSignalForm.invalid);
  }

  decimalToHex(bitmask: number) {
    let hex = Math.round(Number(bitmask)).toString(16);
    while (hex.length < 2) {
      hex = '0' + hex;
    }
    return hex;
  }

  getMax(type: string) {
    if (this.shortData.indexOf(type) !== -1) {
      return this.maxUInt16;
    }
    return this.maxUInt32;
  }

  private generateModbusRegisterForm(signal: ModbusSignal) {
    this.modbusRegisterSignalForm = new UntypedFormGroup({
      dataType: new UntypedFormControl(signal.type, [Validators.required]),
      name: new UntypedFormControl(signal.name, [Validators.required]),
      order: new UntypedFormControl(this.byteOrder[signal.order], [Validators.required]),
      bitmask: new UntypedFormControl(signal.bitmask, [Validators.required]),
    });
    this.formIsValid.emit(!this.modbusRegisterSignalForm.invalid);
  }

  private updateSignalForm() {
    this.formControls.dataType.setValue(this.signal.type);
    this.formControls.name.setValue(this.signal.name);
    this.formControls.order.setValue(this.byteOrder[this.signal.order]);
    this.formControls.bitmask.setValue(this.getMax(this.signal.type));
    this.formIsValid.emit(!this.modbusRegisterSignalForm.invalid);
  }

}
